//  winner: fit review section is visible 

let productRatingFitReview = function(){
  if (document.querySelector("#product-fit-review  .okeReviews ")) {
    // make the true to size line thicker
    let fitWidgetSizeBar = document.querySelector("#product-fit-review .oke-w-header-content .oke-barBlocks--centered");
    if(fitWidgetSizeBar){
        let precentageText = document.querySelector("#product-fit-review .oke-w-header-content .oke-attrBar-title .oke-a11yText").innerText;
        if(precentageText.includes("0.0")){
            fitWidgetSizeBar.querySelector(".oke-barBlocks-bg-shading").style.setProperty("min-width", "30px", "important");
            fitWidgetSizeBar.querySelector(".oke-barBlocks-bg-shading").style.setProperty("transform", "translateX(-13px)", "important");
            fitWidgetSizeBar.querySelector(".oke-barBlocks-bg-centerLine").style.setProperty("background", "transparent", "important");
        }
    }

    // show the reviews count
    let fit_reviews_count = document.querySelector("#product-fit-review .fit-count");
    let product_count = document.querySelector("#product-fit-review .oke-w-navBar-item-count").innerText;
    product_count = Number(product_count.replace(/,/g, ''));
    if (product_count == 0) {
      return;
    }
    if (product_count == 1){
      fit_reviews_count.innerText = Number(product_count).toLocaleString() + " Review";
    }else {
      fit_reviews_count.innerText = Number(product_count).toLocaleString() + " Reviews";
    }
    document.querySelector("#product-fit-review").classList.remove("hidden");

  }
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => { productRatingFitReview(); }, 500);
});


